// 9fbef606107a605d69c0edbcd8029e5d
const ADDRESS_VERIFICATION_CONSTANTS = {
  VERIFY_ADDRESS: 'VERIFY_ADDRESS',
  VERIFY_ADDRESS_SUCCESS: 'VERIFY_ADDRESS_SUCCESS',
  VERIFY_ADDRESS_SUCCESS_DATA: 'VERIFY_ADDRESS_SUCCESS_DATA',
  RESET_AFTERPAY_PAYLOAD: 'RESET_AFTERPAY_PAYLOAD',
  VERIFY_ADDRESS_ERROR: 'VERIFY_ADDRESS_ERROR',
  RESET_VERIFY_ADDRESS: 'RESET_VERIFY_ADDRESS',
  VERIFY_ADDRESS_LINE2_ERROR: 'VERIFY_ADDRESS_LINE2_ERROR',
  VERIFY_ADDRESS_RESULT: {
    VALID: 'valid',
    INVALID: 'invalid',
    INVALID_ERROR: 'invalidError',
    APARTMENT_MISSING: 'apartmentMissing',
    ERROR: 'error',
  },
  VERIFY_ADDRESS_STATUS_MAP: {
    AS01: 'valid',
    AC02: 'valid',
    AE09: 'apartmentMissing',
    AE10: 'invalidError',
    AE11: 'invalidError',
    AE12: 'invalidError',
    ERROR: 'error',
    DEFAULT: 'invalid',
  },
  SHIPPINGANDBILLING: 'ShippingAndBilling',
  VERIFY_ERROR_CODES_MAPPING: {
    INVALID_CODES: ['AE', 'AC'],
    OPTIONAL_ADDRESS_LINE: 'AE09',
    GENERIC_CODES: ['AE02', 'AE07', 'AE10', 'AE12', 'AE13', 'AE14', 'AE01', 'AE11', 'AE08', 'AE03'],
    NO_ACTION_CODES: ['AE06', 'AE15', 'AE16', 'AE17', 'AE19', 'AE20', 'AE21'],
  },
  ADDRESS_FORM_ERROR_CODES: {
    GENERIC_ERROR_CODES: ['AE04', 'AE05'],
    INLINE_ERROR_CODES: [],
  },
  ERROR_CODES: {
    AE01: 'AE01',
    AE08: 'AE08',
  },
  VALID_CODES: 'AS01',
};

export default ADDRESS_VERIFICATION_CONSTANTS;
